import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../../components/dashboard-layout/layout";
import ViewDetailsComponent, {
  TopicType,
  ViewTopic,
} from "../../../components/view-details.component";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { getUsersById } from "../apis/users.api";
import DeleteUserDialog from "../dialogs/delete-user.dialog";
import { UserDetailsEntity } from "../entities/user-details.entity";
import { UserDetailsModel } from "../models/user-details.model";

const topics: ViewTopic[] = [
  {
    title: "First Name",
    contentKey: "firstName",
    type: TopicType.string,
  },
  {
    title: "Last Name",
    contentKey: "lastName",
    type: TopicType.string,
  },
  {
    title: "Email",
    contentKey: "email",
    type: TopicType.string,
  },
  {
    title: "Birth Year",
    contentKey: "birthYear",
    type: TopicType.string,
  },
  {
    title: "Birth Day",
    contentKey: "birthDay",
    type: TopicType.date,
  },
  {
    title: "Created At",
    contentKey: "createdAt",
    type: TopicType.dateTime,
  },
  {
    title: "Email Verified At",
    contentKey: "emailVerifiedAt",
    type: TopicType.dateTime,
  },
  {
    title: "Last Update",
    contentKey: "updatedAt",
    type: TopicType.dateTime,
  },
];

export default function ViewUserPage() {
  const [searchParams] = useSearchParams();
  const [user, setUser] = useState<UserDetailsEntity>();
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const initEffect = useRef<boolean>(false);
  const setAlert = useDashboardStore((state) => state.setAlert);

  useEffect(() => {
    if (initEffect.current === false) {
      const id = searchParams.get("id");
      if (id) {
        getUsersById(id)
          .then((response) => {
            setUser(new UserDetailsModel(response.data).toEntity());
          })
          .catch((error) => {
            setAlert({
              message: error.response.data.message,
              type: AlertType.error,
            });
          });
      }
    }
    return () => {
      initEffect.current = true;
    };
  }, [searchParams, setAlert]);

  return (
    <Layout>
      {user && (
        <DeleteUserDialog
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          user={user}
        />
      )}
      <div className="flex">
        <div className="flex-grow px-4 sm:px-0">
          <h3 className="text-base font-semibold leading-7 text-gray-900">
            User Details
          </h3>
        </div>
        <button
          className="mx-1 rounded-md bg-red-600 px-3 py-1.5 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setDeleteModalOpen(true)}
        >
          Delete
        </button>
      </div>
      {user && <ViewDetailsComponent topics={topics} content={user} />}
    </Layout>
  );
}
